var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup19283(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19283",
    "data-name": "Group 19283",
    transform: "translate(5 11.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8567",
    "data-name": "Rectangle 8567",
    width: 28,
    height: 28,
    transform: "translate(-5 -11.002)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19261",
    "data-name": "Group 19261",
    transform: "translate(0 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8558",
    "data-name": "Rectangle 8558",
    transform: "translate(0 -0.002)",
    fill: "#313131",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8560",
    "data-name": "Rectangle 8560",
    transform: "translate(7 6.998)",
    fill: "#fff",
    stroke: "#313131",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8559",
    "data-name": "Rectangle 8559",
    transform: "translate(8 7.998)",
    fill: "#313131",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19267",
    "data-name": "Group 19267",
    transform: "translate(-1016 -636.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11774",
    "data-name": "Path 11774",
    d: "M-5033.866,14496.256v-2.933h2.826",
    transform: "translate(6054 -13853)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11775",
    "data-name": "Path 11775",
    d: "M-5033.525,14493.584l2.935,2.84",
    transform: "translate(6054 -13853)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19283);
export default __webpack_public_path__ + "static/media/Group 19283.d16d56193dd97b39333095c24643364e.svg";
export { ForwardRef as ReactComponent };